/**
 * 格式化派送点编号显示
 * 根据业务需求：如果 subStopNumber 不为 null 而且不等于 "0"，显示格式为 ${stopNumber}-${subStopNumber}，否则显示为 ${stopNumber}
 *
 * @param stopNumber 派送点编号
 * @param subStopNumber 子派送点编号（字符串类型）
 * @returns 格式化后的派送点编号字符串
 */
export const formatStopNumber = (stopNumber: number, subStopNumber?: string | null): string => {
  if (subStopNumber != null && subStopNumber !== "0" && subStopNumber !== "") {
    return `${stopNumber}-${subStopNumber}`;
  }
  return `${stopNumber}`;
};

/**
 * 解析派送点编号输入
 * 支持格式：
 * - 纯数字（如 "1"）→ 匹配 stop=1 的所有包裹
 * - 带分隔符但未完成的（如 "1-"、"1."）→ 匹配 stop=1 的所有包裹（忽略子编号）
 * - 完整格式（如 "1-1"、"1.1"、"1-a"、"1.b"）→ 匹配 stop=1 且 subStopNumber="1"/"a"/"b" 的包裹
 *   支持子编号为数字或字符串（如 "a", "b", "c"）
 *
 * @param input 用户输入的字符串
 * @returns 解析后的 {stop: number, subStop?: string} 或 null（如果格式不正确）
 */
export const parseStopNumberInput = (input: string): { stop: number; subStop?: string } | null => {
  const trimmed = input.trim();
  if (!trimmed) return null;

  // 尝试匹配完整格式："1-1"、"1.1"、"1-a"、"1.b" 等
  // 子编号可以是数字或字符串（字母、数字、下划线等）
  const completeMatch = trimmed.match(/^(\d+)[-.](.+)$/);
  if (completeMatch) {
    const stop = parseInt(completeMatch[1], 10);
    const subStop = completeMatch[2];
    if (!isNaN(stop) && subStop) {
      return { stop, subStop };
    }
  }

  // 尝试匹配 "1-" 或 "1." 格式（输入过程中）
  // 按照 stop 号匹配：只返回 stop，不返回 subStop，用于筛选所有该 stop 的包裹
  const incompleteMatch = trimmed.match(/^(\d+)[-.]$/);
  if (incompleteMatch) {
    const stop = parseInt(incompleteMatch[1], 10);
    if (!isNaN(stop)) {
      return { stop }; // 只返回 stop，忽略子编号
    }
  }

  // 尝试匹配纯数字格式
  const numberMatch = trimmed.match(/^(\d+)$/);
  if (numberMatch) {
    const stop = parseInt(numberMatch[1], 10);
    if (!isNaN(stop)) {
      return { stop };
    }
  }

  return null;
};

